import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMinimize: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconMinimize"><Path d="M22 3V16H14V14H20V5H5V11H3V3H22Z" fill="currentColor"/><Path d="M13 12V7H15V8.58578L17 6.58578L18.4142 8L16.4142 10H18V12H13Z" fill="currentColor"/><Path d="M12 13V22H2V13H12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMinimize;
